import React, {Component, Fragment} from 'react';
import propertyImg from '../../../assets/img/no-photo-BLACK.png'
import userLogo from '../../../assets/img/nophoto.png'
import {Link} from "react-router-dom";
import {connect} from "react-redux";
import {actionGetAllPropertyList, actionGetPropertyDetails} from "../../../actions/propertysAction";
import {setDataInRedux} from "../../../actions/profile";
import {PROPERTIES} from "../../../actions/types";
import Navbar from "../navbar/Navbar";
import DataNotFound from "../DataNotFound";

class PropertyDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isActiveTab: 'DETAILS',
        }

    }

    componentDidMount() {

        if (this.props.match.params.property_id) {
            this.props.actionGetPropertyDetails(this.props.match.params.property_id)
        }

    }

    componentDidUpdate(pervProps, nextSate) {
        if (pervProps.auth.user._id !== this.props.auth.user._id) {
            this.props.actionGetPropertyDetails(this.props.match.params.property_id)
        }
    }

    setDataReduxChat = ({_id, name, avatar}) => {
        const req = {
            _id,
            name,
            image: avatar,
            is_online: true,

        };
        this.props.setDataInRedux(req);
    };

    render() {
        const {getPropertyDetails} = this.props;
        console.log(getPropertyDetails, "getPropertyDetails");
        return (
            <Fragment>
                <Navbar scenario={PROPERTIES}/>


                <div className='property-details-section'>
                    <div className="container bg-white">
                        <nav aria-label="breadcrumb">
                            <ul className="breadcrumb">
                                <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                                <li className="breadcrumb-item active" aria-current="page">Property Details</li>
                            </ul>
                        </nav>
                        <div className="row">
                            <div className="col-xl-5 col-lg-5 col-12">
                                <div className="agent-contact-section">
                                    <div className="wrapper">
                                        <div className="profile-card js-profile-card">
                                            <div className="profile-card__img">
                                                <img
                                                    src={getPropertyDetails && getPropertyDetails.user ? getPropertyDetails.user.avatar : userLogo}
                                                    alt="profile card"/>
                                            </div>

                                            <div className="profile-card__cnt js-profile-cnt">
                                                <div
                                                    className="profile-card__name">{(getPropertyDetails && getPropertyDetails.user) && getPropertyDetails.user.name}<br/>
                                                    <small> Agent</small>
                                                </div>

                                                <div className="profile-card__txt"><i
                                                    className="fal fa-phone-alt"/> {(getPropertyDetails && getPropertyDetails.user) && getPropertyDetails.user.mobile}
                                                </div>
                                                <div
                                                    className="profile-card__txt"><i
                                                    className="fal fa-envelope"/> {(getPropertyDetails && getPropertyDetails.user) && getPropertyDetails.user.email}
                                                </div>
                                                <div className="profile-card__txt">
                                                    <i className="fal fa-map-marker-alt"/>
                                                    {(getPropertyDetails && getPropertyDetails.user && getPropertyDetails.user.state && getPropertyDetails.user.city.name) && `${getPropertyDetails.user.city.name}, `}
                                                    {(getPropertyDetails && getPropertyDetails.user && getPropertyDetails.user.state && getPropertyDetails.user.state.name) && `${getPropertyDetails.user.state.name}, `}
                                                    {(getPropertyDetails && getPropertyDetails.user && getPropertyDetails.user.state && getPropertyDetails.user.country.name) && `${getPropertyDetails.user.country.name}`}
                                                </div>
                                                <div className="profile-card-loc">

                                                </div>

                                                <div className="profile-card-inf">
                                                    <div className="profile-card-inf__item">
                                                        <div
                                                            className="profile-card-inf__title">{(getPropertyDetails && getPropertyDetails.user && getPropertyDetails.user.property_count ? getPropertyDetails.user.property_count : 0)}</div>
                                                        <div className="profile-card-inf__txt">Properties</div>
                                                    </div>

                                                    <div className="profile-card-inf__item">
                                                        <div
                                                            className="profile-card-inf__title">{(getPropertyDetails && getPropertyDetails.user && getPropertyDetails.user.friends ? getPropertyDetails.user.friends.length : 0)}</div>
                                                        <div className="profile-card-inf__txt">Connections</div>
                                                    </div>
                                                </div>

                                                <div className="profile-card-social">

                                                    <a href={(getPropertyDetails && getPropertyDetails.user && getPropertyDetails.user.facebook_link) && getPropertyDetails.user.facebook_link ? getPropertyDetails.user.facebook_link : '#'}
                                                       className="profile-card-social__item facebook" target="_blank">
          <span className="icon-font">
              <i className="fab fa-facebook-f"></i>
          </span>
                                                    </a>

                                                    <a href={(getPropertyDetails && getPropertyDetails.user && getPropertyDetails.user.twitter_link) && getPropertyDetails.user.twitter_link ? getPropertyDetails.user.twitter_link : '#'}
                                                       className="profile-card-social__item twitter" target="_blank">
          <span className="icon-font">
              <i className="fab fa-twitter"></i>
          </span>
                                                    </a>

                                                    <a href={(getPropertyDetails && getPropertyDetails.user && getPropertyDetails.user.instagram_link) && getPropertyDetails.user.instagram_link ? getPropertyDetails.user.instagram_link : '#'}
                                                       className="profile-card-social__item instagram" target="_blank">
          <span className="icon-font">
              <i className="fab fa-instagram"></i>
          </span>
                                                    </a>


                                                </div>

                                                {/*<div className="profile-card-ctr">*/}
                                                {/*<Link to={`/private-chat`} onClick={()=>this.setDataReduxChat((getPropertyDetails && getPropertyDetails.user) && getPropertyDetails.user)}*/}
                                                {/*className="profile-card__button button--blue js-message-btn" >Message*/}
                                                {/*</Link>*/}
                                                {/*/!*<button className="profile-card__button button--orange">Follow</button>*!/*/}
                                                {/*</div>*/}
                                            </div>


                                        </div>

                                    </div>


                                </div>
                            </div>
                            <div className="col-lg-7 col-xl-7 col-12 ">
                                <div className="property-images">
                                    <img
                                        src={getPropertyDetails && getPropertyDetails.image ? getPropertyDetails.image : propertyImg}
                                        alt="propertyImg"/>
                                </div>
                                <div className="property-details my-3">

                                    <div className="price-description">
                                        <h4 className="m-0 p-0"> {(getPropertyDetails && getPropertyDetails) && getPropertyDetails.currency && getPropertyDetails.currency === "USD" ?
                                            <i className="far fa-dollar-sign custom-text-color2"/> :
                                            <i className="far fa-rupee-sign custom-text-color2"/>} <span
                                            className="custom-text-color2">

                                        {getPropertyDetails && getPropertyDetails.price ?
                                            (getPropertyDetails.price >= 10000000) ? (getPropertyDetails.price / 10000000).toFixed(2) + ' Cr' : (getPropertyDetails.price >= 100000) ? (getPropertyDetails.price / 100000).toFixed(2) + ' Lac' : getPropertyDetails.price : '0'}
                                        </span>
                                            <span className="float-right">
                                        {(getPropertyDetails && getPropertyDetails) && getPropertyDetails.flat_type ? getPropertyDetails && `${getPropertyDetails.flat_type}` : ''}
                                                {(getPropertyDetails && getPropertyDetails) && getPropertyDetails.super_area ? getPropertyDetails && `, ${getPropertyDetails.super_area } ${getPropertyDetails && getPropertyDetails.unit_of_measures.name}` : ''}
                                                {(getPropertyDetails && getPropertyDetails) && getPropertyDetails.carpet_area ? getPropertyDetails && `, ${getPropertyDetails.carpet_area } ${getPropertyDetails && getPropertyDetails.unit_of_measures.name}` : ''}
                                                {(getPropertyDetails && getPropertyDetails) && getPropertyDetails.land_area ? getPropertyDetails && `, ${getPropertyDetails.land_area } ${getPropertyDetails && getPropertyDetails.unit_of_measures.name}` : ''}
                                                {(getPropertyDetails && getPropertyDetails) && getPropertyDetails.plot_area ? getPropertyDetails && `, ${getPropertyDetails.plot_area } ${getPropertyDetails && getPropertyDetails.unit_of_measures.name}` : ''}
                                        </span>
                                        </h4>
                                        <h4>{(getPropertyDetails && getPropertyDetails) && getPropertyDetails.title ? getPropertyDetails.title : ''}</h4>
                                        {(getPropertyDetails && getPropertyDetails) && getPropertyDetails.description &&
                                        <p>{getPropertyDetails.description}</p>}

                                    </div>

                                    <ul className="nav nav-pills mb-3" id="pills-tab" role="tablist">
                                        <li className="nav-item">
                                            <a className="nav-link active font-weight-bold" id="pills-home-tab"
                                               data-toggle="pill"
                                               href="#pills-home"
                                               role="tab" aria-controls="pills-home" aria-selected="true">Property
                                                Details</a>
                                        </li>
                                        <li className="nav-item">
                                            <a className="nav-link font-weight-bold" id="pills-profile-tab"
                                               data-toggle="pill"
                                               href="#pills-profile"
                                               role="tab" aria-controls="pills-profile"
                                               aria-selected="false">Address</a>
                                        </li>
                                        <li className="nav-item">
                                            <a className="nav-link font-weight-bold" id="pills-contact-tab"
                                               data-toggle="pill"
                                               href="#pills-contact"
                                               role="tab" aria-controls="pills-contact"
                                               aria-selected="false">Facility</a>
                                        </li>
                                    </ul>
                                    <div className="tab-content" id="pills-tabContent">
                                        <div className="tab-pane fade show active p-2" id="pills-home" role="tabpanel"
                                             aria-labelledby="pills-home-tab">
                                            <div className="row bg-gray">
                                                {/*<div className="col-12 border-right">*/}
                                                {/*<p className="m-0 p-0">Price:</p>*/}
                                                {/*<p><b>{getPropertyDetails && getPropertyDetails.title}</b></p>*/}
                                                {/*</div>*/}
                                                {(getPropertyDetails && getPropertyDetails.status) &&
                                                <div className="col-lg-4 col-xl-4 col-lg-6 border-right">
                                                    <p className="m-0 p-0">Status:</p>
                                                    <p><b>{getPropertyDetails && getPropertyDetails.status}</b></p>
                                                </div>}
                                                {(getPropertyDetails && getPropertyDetails.booking_amount) &&
                                                <div className="col-lg-4 col-xl-4 col-lg-6 border-right">
                                                    <p className="m-0 p-0">Booking Amount:</p>
                                                    <p><b>{getPropertyDetails && getPropertyDetails.booking_amount}</b>
                                                    </p>
                                                </div>}
                                                {(getPropertyDetails && getPropertyDetails.bedroom) &&
                                                <div className="col-lg-4 col-xl-4 col-lg-6 border-right">
                                                    <p className="m-0 p-0">Bedrooms:</p>
                                                    <p><b>{getPropertyDetails && getPropertyDetails.bedroom}</b></p>
                                                </div>}
                                                {(getPropertyDetails && getPropertyDetails.bathrooms) &&
                                                <div className="col-lg-4 col-xl-4 col-lg-6 border-right">
                                                    <p className="m-0 p-0">Bathrooms:</p>
                                                    <p><b>{getPropertyDetails && getPropertyDetails.bathrooms}</b></p>
                                                </div>}
                                                {(getPropertyDetails && getPropertyDetails.washroom) &&
                                                <div className="col-lg-4 col-xl-4 col-lg-6 border-right">
                                                    <p className="m-0 p-0">Washroom:</p>
                                                    <p><b>{getPropertyDetails && getPropertyDetails.washroom}</b></p>
                                                </div>}
                                                {(getPropertyDetails && getPropertyDetails.pantry) &&
                                                <div className="col-lg-4 col-xl-4 col-lg-6 border-right">
                                                    <p className="m-0 p-0">Pantry:</p>
                                                    <p><b>{getPropertyDetails && getPropertyDetails.pantry}</b></p>
                                                </div>}
                                                {(getPropertyDetails && getPropertyDetails.construction_status) &&
                                                <div className="col-lg-4 col-xl-4 col-lg-6 border-right">
                                                    <p className="m-0 p-0">Construction Status:</p>
                                                    <p>
                                                        <b>{getPropertyDetails && getPropertyDetails.construction_status}</b>
                                                    </p>
                                                </div>}
                                                {(getPropertyDetails && getPropertyDetails.building_class) &&
                                                <div className="col-lg-4 col-xl-4 col-lg-6 border-right">
                                                    <p className="m-0 p-0">Building Class:</p>
                                                    <p><b>{getPropertyDetails && getPropertyDetails.building_class}</b>
                                                    </p>
                                                </div>}
                                                {(getPropertyDetails && getPropertyDetails.transaction_type) &&
                                                <div className="col-lg-4 col-xl-4 col-lg-6 border-right">
                                                    <p className="m-0 p-0">Transaction Type:</p>
                                                    <p>
                                                        <b>{getPropertyDetails && getPropertyDetails.transaction_type}</b>
                                                    </p>
                                                </div>}
                                                {(getPropertyDetails && getPropertyDetails.furnished_status) &&
                                                <div className="col-lg-4 col-xl-4 col-lg-6 border-right">
                                                    <p className="m-0 p-0">Furnished Status:</p>
                                                    <p>
                                                        <b>{getPropertyDetails && getPropertyDetails.furnished_status}</b>
                                                    </p>
                                                </div>}
                                                {(getPropertyDetails && getPropertyDetails.flooring) &&
                                                <div className="col-lg-4 col-xl-4 col-lg-6 border-right">
                                                    <p className="m-0 p-0">Flooring:</p>
                                                    <p><b>{getPropertyDetails && getPropertyDetails.flooring}</b></p>
                                                </div>}
                                                {(getPropertyDetails && getPropertyDetails.home_size) &&
                                                <div className="col-lg-4 col-xl-4 col-lg-6 border-right">
                                                    <p className="m-0 p-0">Home Size:</p>
                                                    <p><b>{getPropertyDetails && getPropertyDetails.home_size}</b></p>
                                                </div>}
                                                {(getPropertyDetails && getPropertyDetails.rera_id) &&
                                                <div className="col-lg-4 col-xl-4 col-lg-6 border-right">
                                                    <p className="m-0 p-0">RERA ID:</p>
                                                    <p><b>{getPropertyDetails && getPropertyDetails.rera_id}</b></p>
                                                </div>}
                                                {(getPropertyDetails && getPropertyDetails.list_date) &&
                                                <div className="col-lg-4 col-xl-4 col-lg-6 border-right">
                                                    <p className="m-0 p-0">List Date:</p>
                                                    <p><b>{getPropertyDetails && getPropertyDetails.list_date}</b></p>
                                                </div>}
                                                {(getPropertyDetails && getPropertyDetails.car_parking) &&
                                                <div className="col-lg-4 col-xl-4 col-lg-6 border-right">
                                                    <p className="m-0 p-0">Parking:</p>
                                                    <p><b>{getPropertyDetails && getPropertyDetails.car_parking}</b></p>
                                                </div>}
                                                {(getPropertyDetails && getPropertyDetails.type_of_ownership) &&
                                                <div className="col-lg-4 col-xl-4 col-lg-6 border-right">
                                                    <p className="m-0 p-0">Type Of Ownership:</p>
                                                    <p>
                                                        <b>{getPropertyDetails && getPropertyDetails.type_of_ownership}</b>
                                                    </p>
                                                </div>}
                                                {(getPropertyDetails && getPropertyDetails.age_of_property) &&
                                                <div className="col-lg-4 col-xl-4 col-lg-6 border-right">
                                                    <p className="m-0 p-0">Age Of Property:</p>
                                                    <p><b>{getPropertyDetails && getPropertyDetails.age_of_property}</b>
                                                    </p>
                                                </div>}
                                                {(getPropertyDetails && getPropertyDetails.no_of_cabins) &&
                                                <div className="col-lg-4 col-xl-4 col-lg-6 border-right">
                                                    <p className="m-0 p-0">No Of Cabins:</p>
                                                    <p><b>{getPropertyDetails && getPropertyDetails.no_of_cabins}</b>
                                                    </p>
                                                </div>}
                                                {(getPropertyDetails && getPropertyDetails.no_of_conf_room) &&
                                                <div className="col-lg-4 col-xl-4 col-lg-6 border-right">
                                                    <p className="m-0 p-0">No Of Conf Room:</p>
                                                    <p><b>{getPropertyDetails && getPropertyDetails.no_of_conf_room}</b>
                                                    </p>
                                                </div>}
                                                {(getPropertyDetails && getPropertyDetails.name_of_industrial_estate) &&
                                                <div className="col-lg-4 col-xl-4 col-lg-6 border-right">
                                                    <p className="m-0 p-0">Name Of Industrial Estate:</p>
                                                    <p>
                                                        <b>{getPropertyDetails && getPropertyDetails.name_of_industrial_estate}</b>
                                                    </p>
                                                </div>}
                                                {(getPropertyDetails && getPropertyDetails.corner_plot) &&
                                                <div className="col-lg-4 col-xl-4 col-lg-6 border-right">
                                                    <p className="m-0 p-0">Corner Plot:</p>
                                                    <p><b>{getPropertyDetails && getPropertyDetails.corner_plot}</b></p>
                                                </div>}
                                                {(getPropertyDetails && getPropertyDetails.units_on_floor) &&
                                                <div className="col-lg-4 col-xl-4 col-lg-6 border-right">
                                                    <p className="m-0 p-0">Units On Floor:</p>
                                                    <p><b>{getPropertyDetails && getPropertyDetails.units_on_floor}</b>
                                                    </p>
                                                </div>}
                                                {(getPropertyDetails && getPropertyDetails.leed_certificate) &&
                                                <div className="col-lg-4 col-xl-4 col-lg-6 border-right">
                                                    <p className="m-0 p-0">LEED Certificate:</p>
                                                    <p>
                                                        <b>{getPropertyDetails && getPropertyDetails.leed_certificate}</b>
                                                    </p>
                                                </div>}
                                                {(getPropertyDetails && getPropertyDetails.fire_equipment) &&
                                                <div className="col-lg-4 col-xl-4 col-lg-6 border-right">
                                                    <p className="m-0 p-0">Fire Equipment:</p>
                                                    <p><b>{getPropertyDetails && getPropertyDetails.fire_equipment}</b>
                                                    </p>
                                                </div>}
                                                {(getPropertyDetails && getPropertyDetails.pre_leased_property) &&
                                                <div className="col-lg-4 col-xl-4 col-lg-6 border-right">
                                                    <p className="m-0 p-0">Pre Leased Property:</p>
                                                    <p>
                                                        <b>{getPropertyDetails && getPropertyDetails.pre_leased_property}</b>
                                                    </p>
                                                </div>}
                                                {(getPropertyDetails && getPropertyDetails.landmarks) &&
                                                <div className="col-lg-4 col-xl-4 col-lg-6 border-right">
                                                    <p className="m-0 p-0">Landmarks:</p>
                                                    <p><b>{getPropertyDetails && getPropertyDetails.landmarks}</b></p>
                                                </div>}
                                            </div>

                                        </div>
                                        <div className="tab-pane fade p-2" id="pills-profile" role="tabpanel"
                                             aria-labelledby="pills-profile-tab">
                                            <div className="row bg-gray">
                                                <div className="col-12 border-right">
                                                    <p className="m-0 p-0">Address:</p>
                                                    <p><b>{getPropertyDetails && getPropertyDetails.address}</b></p>
                                                </div>
                                                <div className="col-lg-4 col-xl-4 col-lg-6 border-right">
                                                    <p className="m-0 p-0">Street:</p>
                                                    <p><b>{getPropertyDetails && getPropertyDetails.street}</b></p>
                                                </div>
                                                <div className="col-lg-4 col-xl-4 col-lg-6 border-right">
                                                    <p className="m-0 p-0">City:</p>
                                                    <p><b>{getPropertyDetails && getPropertyDetails.city.name}</b></p>
                                                </div>
                                                <div
                                                    className="col-lg-4 col-xl-4 col-lg-6 border-right">
                                                    <p className="m-0 p-0">State:</p>
                                                    <p><b>{getPropertyDetails && getPropertyDetails.state.name}</b></p>
                                                </div>
                                                <div
                                                    className="col-lg-4 col-xl-4 col-lg-6 border-right">
                                                    <p className="m-0 p-0">Country:</p>
                                                    <p><b>{getPropertyDetails && getPropertyDetails.country.name}</b>
                                                    </p>
                                                </div>

                                                <div className="col-lg-4 col-xl-4 col-lg-6 border-right">
                                                    <p className="m-0 p-0">ZIP:</p>
                                                    <p><b>{getPropertyDetails && getPropertyDetails.zip_code}</b></p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="tab-pane fade p-2" id="pills-contact" role="tabpanel"
                                             aria-labelledby="pills-contact-tab">
                                            <div className="row">
                                                {(getPropertyDetails && getPropertyDetails.amenities && getPropertyDetails.amenities.length > 0) ? getPropertyDetails.amenities.map((data, index) =>
                                                    <div className="col-6" key={index}>
                                                        <p className=" font-weight-bold active-amenity1 border-bottom">
                                                            {index + 1}. {data.name}
                                                        </p>
                                                    </div>
                                                ) : <div className="m-auto">
                                                    <DataNotFound message={"Not Found"}/>
                                                </div>
                                                }

                                            </div>

                                        </div>
                                    </div>
                                    <div>
                                        {getPropertyDetails && getPropertyDetails.disclaimer &&
                                        <p>{getPropertyDetails.disclaimer} </p>}
                                    </div>


                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }
}


const mapStateToProps = (state) => ({
    auth: state.auth,
    getAllPropertiesLoader: state.property.getAllPropertiesLoader,
    getPropertyDetails: state.property.getPropertyDetails,
    agents: state.profile.agents
});

export default connect(mapStateToProps, {actionGetPropertyDetails, setDataInRedux})(PropertyDetails)
